const THOUSAND_DIVIDER = ',';
const MAX_ORDER = 7;
const MAX_DECIMAL_ORDER = 2;

export const formatNumber = (value: string | number, acceptsDecimals = false): string => {
  if (typeof value === 'number') {
    return value.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, THOUSAND_DIVIDER);
  }

  if (typeof value !== 'string') {
    return '';
  }

  let val = value.replace(/,/g, '');
  let decimal: string | null = null;

  if (val.includes('.')) {
    if (acceptsDecimals) {
      [val, decimal] = val.split('.');

      if (decimal.length > MAX_DECIMAL_ORDER) {
        decimal = decimal.substring(0, decimal.length - 1);
      }
    } else {
      val = val.substring(0, val.length - 1);
    }
  }

  if (!/^[0-9.]+$/.test(val) || val.length > MAX_ORDER) {
    val = val.substring(0, val.length - 1);
  }

  val = (+val).toFixed();

  if (Number.isNaN(+val)) {
    return '';
  }

  const formatted = val.replace(/\B(?=(\d{3})+(?!\d))/g, THOUSAND_DIVIDER);

  return decimal !== null ? `${formatted}.${decimal}` : formatted;
};

export const processFormattedNumber = (value: string | number) => {
  if (typeof value !== 'string') {
    return value;
  }

  if (value.includes('.') && value[value.length - 1] === '.') {
    return value.substring(0, value.length - 1);
  }

  return value.replaceAll(',', '');
};

export function minutesToHHMM(inputMinutes: string): string {
  const minsNum = parseFloat(inputMinutes);
  let hours: number | string = Math.floor(minsNum / 60);
  let minutes: number | string = Math.floor(minsNum - (hours * 3600) / 60);

  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  return `${hours}:${minutes}`;
}

export const dateFormatForAPI = (date: Date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
};

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
}

export default { minutesToHHMM, dateFormatForAPI, capitalize };
